export enum FileBrowserViewMode {
  Icon = 'icon',
  List = 'list'
}
